export default __webpack_public_path__ + "static/media/contract.ac31486b.svg";